import React, {memo} from 'react';
import Dialog from 'components/Dialog';
import {Grid} from '@mui/material';
import {FormFooterButtons} from 'components/buttons/FormFooterButtons';
import * as yup from 'common/yup';
import Formik, {FormOnSubmitHelpers} from 'components/hook-form/Formik';
import {FormAutocomplete} from 'components/inputs/FormAutocomplete';
import {DropdownObjectOption} from 'components/inputs/Dropdown';

const validationSchema = yup.object({
   value: yup.string().required(),
});
export type SelectDialogFormType = yup.InferType<typeof validationSchema>;

export interface SelectDialogDialogProps {
   data: {
      title: string;
      label: string;
      options: DropdownObjectOption[];
      open?: boolean;
      value?: string;
   };
   onClose: (
      nameObj?: SelectDialogFormType,
      callbacks?: FormOnSubmitHelpers<SelectDialogFormType>
   ) => void;
}
export const SelectDialog = memo(
   ({
      data: {title, value, open = true, label, options},
      onClose: onSubmit,
   }: SelectDialogDialogProps) => {
      const onClose = React.useCallback(() => onSubmit(), [onSubmit]);
      return (
         <Dialog open={open} maxWidth="sm" header={title} close={onClose}>
            <Formik
               initialValues={validationSchema.cast({value})}
               initialTouched={Boolean(value) ? ['value'] : undefined}
               validationSchema={validationSchema}
               onSubmit={onSubmit}
            >
               <SelectDialogForm cancel={onClose} label={label} options={options} />
            </Formik>
         </Dialog>
      );
   }
);

const SelectDialogForm = ({
   label,
   cancel,
   options,
}: {
   label: string;
   cancel: () => void;
   options: DropdownObjectOption[];
}) => {
   return (
      <>
         <Grid container spacing={3} justifyContent="center">
            <Grid item sm={11}>
               <FormAutocomplete
                  // autoFocus
                  name="value"
                  label={label}
                  options={options}
               />
            </Grid>
         </Grid>
         <Grid container spacing={3} justifyContent="center">
            <Grid item>
               <FormFooterButtons cancel={cancel} />
            </Grid>
         </Grid>
      </>
   );
};
